import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-model/fulfillments/metrics";

export const getMergedOrderSavings = {
  name: "getMergedOrderSavings" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
